<template>
  <section class="my-nav">
    <div class="m-nav">
      <div class="m-nav-content" ref="nav">
        <p
          v-for="(item, index) in list"
          :key="index"
          :class="['m-nav-title', activeIdx === index && 'active']"
          @click="switchTab($event, index)"
        >
          {{ item.name }}
        </p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      activeIdx: 0,
    };
  },
  props: {
    list: Array,
    currentIndex: 0,
  },
  methods: {
    switchTab(ev, index) {
      if (index !== this.activeIdx) {
        this.activeIdx = index;
        const spanLeft = ev.clientX;
        const divBox = document.querySelector(".active").clientWidth / 2;
        const totalWidths = document.body.clientWidth;
        const widths = totalWidths / 2;
        const spanRight = totalWidths - spanLeft;
        const scrollBox = document.querySelector(".m-nav");
        const scrollL = scrollBox.scrollLeft;
        if (spanRight < 100 || spanLeft < 100) {
          scrollBox.scrollLeft = scrollL + (spanLeft - widths) + divBox;
        }
        this.$emit("sendIndex", { index });
      }
    },
  },
  watch: {
    currentIndex: {
      handler: function (val, oldVal) {
        this.$nextTick(() => {
          this.$refs.nav.children[val || 0].click();
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.my-nav {
  margin-top: 12px;
}
.m-nav {
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}
.m-nav-content {
  display: flex;
}
.m-nav-title {
  padding: 0.2rem 0.26rem;
  color: #141414;
  font-size: 0.3rem;
  flex-shrink: 0;
  height: 0.52rem;
  line-height: 0.52rem;
  font-weight: bold;
  background-image: linear-gradient(#fff,rgba(255,255,255,0.4));
}
.m-nav-title.active {
  color: #f00;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
.mobile_css ::-webkit-scrollbar {
  width: 0.01rem;
  opacity: 0;
  display: none;
}
/*定义滚动条轨道 内阴影+圆角*/
.mobile_css ::-webkit-scrollbar-track {
  background-color: #fff;
  opacity: 0;
}
/*定义滑块 内阴影+圆角*/
.mobile_css ::-webkit-scrollbar-thumb {
  width: 0.01rem;
  border-radius: 0.01rem;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyNav/index.vue